var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"func5"},[_c('Func5BuscaMedicamentos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }